import axios from '@/config/http'
import ip from '../config/ip.js'

let base = ip.Ips.ip1

export const getAutomaticDispatchM4 = () => {
  return axios.get(
    `${base}/system/parameterInfoBusiness/getSendM4Config`,
  );
};

export const updateAutomaticDispatchM4 = () => {
  return axios.post(
    `${base}/system/parameterInfoBusiness/updateSendM4Config`,
  );
};



// WEBPACK FOOTER //
// ./src/api/dispatchConfiguration.js